import PropTypes from 'prop-types';
import { BetaButton, Spinner } from '@bevy/bevy-design-system';
import styles from './styles.module.less';

/**
 * LoaderButton - generic button that can display a loading spinner
 * @param {object} buttonProps - props to pass to the button to override styles
 * @param {string} buttonText - text to display on the button
 * @param {function} onClick - function to call when the button is clicked
 * @param {boolean} disabled - whether the button is disabled
 * @param {string} dataHelpId - help id for the button
 * @param {boolean} isLoading - whether the button is in a loading state
 * @returns {React.Component}
 */
const LoaderButton = ({
  buttonProps = {},
  children = null,
  onClick = () => {},
  disabled = false,
  dataHelpId = '',
  isLoading = false,
}) => {
  return (
    <BetaButton
      type='button'
      size='small'
      spacing='standard'
      onClick={onClick}
      disabled={disabled}
      dataHelpId={dataHelpId}
      {...buttonProps}
    >
      <div className={styles.innerButton}>
        {isLoading && (
          <div data-testid='loader'>
            <Spinner />
          </div>
        )}
        {children}
      </div>
    </BetaButton>
  );
};

LoaderButton.propTypes = {
  buttonProps: PropTypes.object,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  dataHelpId: PropTypes.string,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  onClick: PropTypes.func,
};

export default LoaderButton;
